export default {
  allMsg: 'Wszystkie wiadomości',
  systemMsg: 'Wiadomości systemowe',
  personMsg: 'Wiadomości ręczne',
  unread: 'Nieprzeczytane',
  seeDetail: 'Zobacz szczegóły',
  read: 'Przeczytane',
  replyNow: 'odpowiedz teraz',
  message: 'Wiadomość',
  operateSuccess: 'Operacja zakończona pomyślnie',
  holder: {
    searchHolder: 'Nr paczki/Nr zamówienia/Nr przedmiotu',
  },
  addAcBuy: 'Dołącz do Discorda AcBuy i wygraj ¥2000 w gotówce! ',
  joinNow: 'Dołącz tutaj',
  flatActivity: 'Podziel się, jak robisz zakupy na Taobao i AcBuy — Wygraj ¥1500 w gotówce!',
  joinNow1: 'Dołącz teraz',
  tips1: 'Oficjalne rozdanie Labubu od Acbuy',
  tips2: 'Wielka rozdawka Labubu i pełny zestaw ZIMOMO',
}
